import { createContext, useContext } from 'react'

interface HeaderActionsContextValue {
    onNavigate: (page: string) => void
    onNavigateToNote?: (noteId: string, beneficiaryId: string) => void
}

export const HeaderActionsContext = createContext<HeaderActionsContextValue | null>(null)
export const useHeaderActions = () => useContext(HeaderActionsContext)
